<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Create Text Messaging Campaign</h2>
      <button class="close-button" (click)="onClose()">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3L3 9M3 3L9 9" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Form Section -->
      <div class="form-section">

        <!-- Message Type Selector -->
        <div class="message-type-selector">
          <button class="message-type-btn" [class.active]="messageType === 'SMS'" (click)="setMessageType('SMS')">
            <span class="type-label">SMS</span>
            <span class="type-sub">Text · 160 chars</span>
          </button>
          <button class="message-type-btn" [class.active]="messageType === 'MMS'" (click)="setMessageType('MMS')">
            <span class="type-label">MMS</span>
            <span class="type-sub">Text + Image</span>
          </button>
        </div>

        <!-- Split into two bubbles (MMS only) -->
        <div class="form-group" *ngIf="messageType === 'MMS'">
          <div class="split-toggle-row">
            <div class="split-toggle-label">
              <span>Split into two bubbles</span>
              <span class="info-tooltip-wrapper">
                <svg class="info-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="7.5" stroke="#A7ABB3"/>
                  <path d="M8 7.5v3M8 5v.5" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span class="info-tooltip">
                  You can add the image and text in one block, or choose to add them in separate blocks (image bubble + text bubble).
                </span>
              </span>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="splitTwoBubbles">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>

        <!-- ===== SMS Mode Fields ===== -->
        <ng-container *ngIf="messageType === 'SMS'">
          <!-- Sender ID (SMS) -->
          <div class="form-group">
            <label class="form-label">Sender ID / Number<span class="required">*</span></label>
            <input
              type="text"
              class="form-input"
              [class.error]="senderIdTouched && senderIdError"
              [(ngModel)]="senderId"
              (blur)="onSenderIdBlur()"
              (input)="onSenderIdInput($event)"
              [maxlength]="maxSenderIdLength"
              placeholder="e.g. 01 1892301293"
            />
            <div class="error-message" *ngIf="senderIdTouched && senderIdError">{{ senderIdError }}</div>
          </div>
          <!-- Text Message Field -->
          <div class="form-group">
            <label class="form-label">Text messages<span class="required">*</span></label>
            <div class="message-input-container">
              <div
                #textAreaRef
                class="form-textarea contenteditable-textarea"
                contenteditable="true"
                (input)="onTextInput($event)"
                (paste)="onTextPaste($event)"
                (blur)="onTextMessageBlur()"
                (focus)="onTextAreaFocus()"
                (click)="onTextAreaClick()"
                (keydown)="onTextAreaKeyDown($event)"
                [attr.data-placeholder]="textMessage ? '' : 'Write the text of your message here. Describe the offers in this campaign and why it can\'t be missed.'"
              ></div>
              <div class="textarea-footer-row">
                <span class="char-counter-left">{{ smsTextSegmentInfo.chars }} characters · {{ smsTextSegmentInfo.encoding }}</span>
                <span class="segment-badge" [class.error]="smsTextSegmentInfo.segments > maxTextSegments">{{ smsTextSegmentInfo.segments }} segment{{ smsTextSegmentInfo.segments === 1 ? '' : 's' }}</span>
              </div>
              <div class="error-message" *ngIf="textMessageSegmentError">
                {{ textMessageSegmentError }}
              </div>
              <span class="insert-var-label">Insert a variable</span>
              <div class="tags-section">
                <div class="tag"
                     *ngFor="let tag of availableTags; trackBy: trackByIndex"
                     (click)="insertTag(tag.name)">
                  {{ tag.display }}
                </div>
              </div>
            </div>
          </div>

          <!-- Link Text Field -->
          <div class="form-group">
            <label class="form-label">Link texts</label>
            <input
              type="text"
              class="form-input"
              [class.error]="linkTextTouched && linkTextError"
              [(ngModel)]="linkText"
              (blur)="onLinkTextBlur()"
              (input)="onLinkTextInput($event)"
              [maxlength]="maxLinkTextLength"
              placeholder="https://example.com"
            />
            <div class="error-message" *ngIf="linkTextTouched && linkTextError">
              {{ linkTextError }}
            </div>
          </div>
        </ng-container>

        <!-- ===== MMS Mode Fields ===== -->
        <ng-container *ngIf="messageType === 'MMS'">

          <!-- ---- Message bubble 1 ---- -->
           <ng-container *ngIf="splitTwoBubbles">
            <div class="bubble-section-title">Message bubble 1</div>
           </ng-container>
          
          <div class="bubble-section-sublabel">Coupon image (MMS)</div>

          <!-- Image Upload -->
          <div class="form-group">
            <label class="form-label">Image <span class="required">*</span><span class="field-hint"> — PNG or JPG, max 5 MB</span></label>
            <input #mmsFileInput type="file" accept=".png,.jpg,.jpeg" (change)="onMmsFileSelected($event)" style="display:none">
            <div class="image-upload-zone"
                 (click)="mmsFileInput.click()"
                 (dragover)="onMmsFileDragOver($event)"
                 (drop)="onMmsFileDrop($event)"
                 [class.has-image]="mmsImagePreviewUrl"
                 [class.error]="mmsImageTouched && mmsImageError">
              <ng-container *ngIf="!mmsImagePreviewUrl">
                <div class="upload-icon-wrapper">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 16V8M12 8L9 11M12 8L15 11" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3 16.5V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V16.5" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <p class="upload-text">Drag & drop your file here or <span class="browse-link">browse</span> to upload</p>
                <p class="upload-hint">Supported: PNG, JPG · max file size 5 MB</p>
              </ng-container>
              <img *ngIf="mmsImagePreviewUrl" [src]="mmsImagePreviewUrl" class="image-preview-thumb" alt="MMS preview">
            </div>
            <div class="error-message" *ngIf="mmsImageTouched && mmsImageError">{{ mmsImageError }}</div>
          </div>

          <!-- Alternative Text -->
          <div class="form-group">
            <label class="form-label">Alternative text <span class="field-hint">— shown if the image can't load</span></label>
            <input
              type="text"
              class="form-input"
              [(ngModel)]="mmsAltText"
              placeholder="e.g. Summer Shine 20% off coupon"
            />
          </div>

          <!-- Caption -->
          <div class="form-group">
            <label class="form-label">Caption <span class="field-hint">— text shown with the image</span></label>
            <textarea
              class="form-textarea mms-textarea"
              [class.error]="mmsCaptionSegmentError"
              [ngModel]="mmsCaption"
              (ngModelChange)="onMmsCaptionChange($event)"
              (keydown)="onMmsCaptionKeyDown($event)"
              placeholder="Enter caption text"
              rows="3"
            ></textarea>
            <div class="textarea-footer-row">
              <span class="char-counter-left">{{ mmsCaptionSegmentInfo.chars }} characters · {{ mmsCaptionSegmentInfo.encoding }}</span>
              <span class="segment-badge mms-badge" [class.error]="mmsCaptionSegmentInfo.segments > maxMmsSegments">{{ mmsCaptionSegmentInfo.segments }} segment{{ mmsCaptionSegmentInfo.segments === 1 ? '' : 's' }}</span>
            </div>
            <div class="error-message" *ngIf="mmsCaptionSegmentError">{{ mmsCaptionSegmentError }}</div>
            <div class="tags-section" *ngIf="mmsCaptionTags.length">
              <div class="tag" *ngFor="let tag of mmsCaptionTags; trackBy: trackByIndex" (click)="insertMmsCaptionTag(tag.name)">
                {{ tag.display }}
              </div>
            </div>
          </div>

          <!-- URL -->
          <div class="form-group">
            <label class="form-label">URL <span class="field-hint">— optional, opens when the customer taps</span></label>
            <div class="url-input-wrapper">
              <input
                type="text"
                class="form-input"
                [class.url-valid]="mmsUrlValid"
                [(ngModel)]="mmsUrl"
                (input)="onMmsUrlInput()"
                (blur)="onMmsUrlBlur()"
                placeholder="https://example.com"
              />
              <svg *ngIf="mmsUrlValid" class="url-check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 8.5L6.5 12L13 5" stroke="#22C55E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="url-looks-good" *ngIf="mmsUrlValid">Looks good</span>
            <span class="error-message" *ngIf="mmsUrlTouched && mmsUrlError">{{ mmsUrlError }}</span>
          </div>

          <!-- MMS Fallback -->
          <div class="mms-fallback-section">
            <div class="fallback-header-label">
              <span class="fallback-label">MMS fallback</span>
              <span class="fallback-desc"> — used if the device can't receive MMS</span>
            </div>
            <div class="form-group">
              <label class="form-label">Behavior</label>
              <select class="form-select" [(ngModel)]="mmsFallbackBehavior">
                <option value="send-sms-with-image-link">Send SMS with image link</option>
                <option value="send-sms-without-image">Send SMS without image</option>
                <option value="do-not-send">Do not send</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Fallback text <span class="required">*</span></label>
              <textarea
                class="form-textarea mms-textarea"
                [class.error]="(mmsFallbackTextTouched && mmsFallbackTextError) || mmsFallbackSegmentError"
                [ngModel]="mmsFallbackText"
                (ngModelChange)="onMmsFallbackTextChange($event)"
                (keydown)="onMmsFallbackTextKeyDown($event)"
                (blur)="onMmsFallbackTextBlur()"
                placeholder="Enter fallback message"
                rows="3"
              ></textarea>
              <div class="textarea-footer-row">
                <span class="char-counter-left">{{ mmsFallbackSegmentInfo.chars }} characters · {{ mmsFallbackSegmentInfo.encoding }}</span>
                <span class="segment-badge" [class.error]="mmsFallbackSegmentInfo.segments > maxMmsSegments">{{ mmsFallbackSegmentInfo.segments }} segment{{ mmsFallbackSegmentInfo.segments === 1 ? '' : 's' }}</span>
              </div>
              <div class="error-message" *ngIf="mmsFallbackTextTouched && mmsFallbackTextError">{{ mmsFallbackTextError }}</div>
              <div class="error-message" *ngIf="mmsFallbackSegmentError">{{ mmsFallbackSegmentError }}</div>
              <!--<div class="tags-section" *ngIf="mmsFallbackTags.length">
                <div class="tag" *ngFor="let tag of mmsFallbackTags; trackBy: trackByIndex" (click)="insertMmsFallbackTag(tag.name)">
                  {{ tag.display }} 
                </div>
              </div>-->
            </div>
          </div>

          <!-- ---- Message bubble 2 (shown only when split toggle is ON) ---- -->
          <ng-container *ngIf="splitTwoBubbles">
            <div class="bubble-section-title bubble-section-title--2">Message bubble 2</div>
            <div class="bubble-section-sublabel">Message body</div>

            <div class="form-group">
              <label class="form-label">Text <span class="required">*</span></label>
              <textarea
                class="form-textarea mms-textarea mms-textarea--tall"
                [class.error]="mmsBubble2SegmentError"
                [ngModel]="mmsBubble2Text"
                (ngModelChange)="onMmsBubble2TextChange($event)"
                (keydown)="onMmsBubble2TextKeyDown($event)"
                placeholder="Write your message here"
                rows="5"
              ></textarea>
              <div class="textarea-footer-row">
                <span class="char-counter-left">{{ mmsBubble2SegmentInfo.chars }} characters · {{ mmsBubble2SegmentInfo.encoding }}</span>
                <span class="segment-badge" [class.error]="mmsBubble2SegmentInfo.segments > maxMmsSegments">{{ mmsBubble2SegmentInfo.segments }} segment{{ mmsBubble2SegmentInfo.segments === 1 ? '' : 's' }}</span>
              </div>
              <div class="error-message" *ngIf="mmsBubble2SegmentError">{{ mmsBubble2SegmentError }}</div>
            </div>

            <div class="insert-var-section">
              <span class="insert-var-label">Insert a variable</span>
              <div class="tags-section">
                <div class="tag" *ngFor="let tag of mmsBubble2Tags; trackBy: trackByIndex" (click)="insertMmsBubble2Tag(tag.name)">
                  {{ tag.display }}
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- Preview Section (SMS) -->
      <!-- Preview Section (SMS) -->
      <div class="preview-section" *ngIf="messageType === 'SMS'">
        <div class="preview-header">
          <h3 class="preview-title">Preview</h3>
        </div>
        <div class="message-preview">

          <!-- Single segment -->
          <ng-container *ngIf="smsSegmentParts.length <= 1">
            <div class="message-bubble">
              <div class="message-content">
                <div class="message-text">{{ getPreviewMessage() }}
                  <ng-container *ngIf="linkText.trim()">
                    <br><br>
                    <span class="link-text">{{ linkText }}</span>
                  </ng-container>
                </div>
              </div>
              <div class="message-tail"></div>
            </div>
          </ng-container>

          <!-- Multi-segment: one bubble per segment -->
          <ng-container *ngIf="smsSegmentParts.length > 1">
            <div class="segment-group"
                 *ngFor="let part of smsSegmentParts; let i = index; trackBy: trackByIndex">
              <span class="segment-label">Segment {{ i + 1 }} of {{ smsSegmentParts.length }}</span>
              <div class="message-bubble">
                <div class="message-content">
                  <div class="message-text">{{ part }}</div>
                </div>
                <div class="message-tail"></div>
              </div>
            </div>
          </ng-container>

        </div>

        <!-- SMS Cost Breakdown -->
        <div class="mms-cost-breakdown">
          <div class="cost-row">
            <span class="cost-label">Channel</span>
            <span class="cost-value">SMS</span>
          </div>
          <div class="cost-row">
            <span class="cost-label">Encoding</span>
            <span class="cost-value cost-value--encoding">{{ smsTextSegmentInfo.encoding }}</span>
          </div>
          <div class="cost-row">
            <span class="cost-label">Characters</span>
            <span class="cost-value">{{ smsTextSegmentInfo.chars }}</span>
          </div>
          <div class="cost-row">
            <span class="cost-label">Segments</span>
            <span class="cost-value">{{ smsTotalSegmentCount }} × $0.0083</span>
          </div>
          <div class="cost-row cost-total-row">
            <span class="cost-total-label">Cost / recipient</span>
            <span class="cost-total-value">${{ formatCost(smsTotalCost) }}</span>
          </div>
        </div>

      </div>

      <!-- Preview Section (MMS) -->
      <div class="preview-section mms-preview-section" *ngIf="messageType === 'MMS'">
        <div class="preview-header">
          <h3 class="preview-title">Preview</h3>
        </div>

        <!-- MMS Bubbles Preview -->
        <div class="mms-preview-bubbles">
          <!-- Bubble 1: image + caption + url -->

          <!-- Single caption segment (or no caption) -->
          <div class="mms-message-bubble" *ngIf="mmsCaptionSegmentParts.length <= 1">
            <div class="mms-message-content">
              <div class="mms-image-preview-box">
                <img *ngIf="mmsImagePreviewUrl" [src]="mmsImagePreviewUrl" class="mms-image-preview-img" alt="MMS Image">
                <span *ngIf="!mmsImagePreviewUrl" class="mms-image-placeholder-text">Image preview</span>
              </div>
              <div class="mms-preview-caption" *ngIf="mmsCaption">{{ mmsCaption }}</div>
              <div class="mms-preview-url" *ngIf="mmsUrl">{{ mmsUrl }}</div>
            </div>
            <div class="message-tail"></div>
          </div>

          <!-- Multi-segment caption: image + url stay with first segment only -->
          <ng-container *ngIf="mmsCaptionSegmentParts.length > 1">
            <div class="segment-group"
                 *ngFor="let part of mmsCaptionSegmentParts; let i = index; trackBy: trackByIndex">
              <span class="segment-label">Caption Segment {{ i + 1 }} of {{ mmsCaptionSegmentParts.length }}</span>
              <div class="mms-message-bubble">
                <div class="mms-message-content">
                  <div class="mms-image-preview-box" *ngIf="i === 0">
                    <img *ngIf="mmsImagePreviewUrl" [src]="mmsImagePreviewUrl" class="mms-image-preview-img" alt="MMS Image">
                    <span *ngIf="!mmsImagePreviewUrl" class="mms-image-placeholder-text">Image preview</span>
                  </div>
                  <div class="mms-preview-caption">{{ part }}</div>
                  <div class="mms-preview-url" *ngIf="i === 0 && mmsUrl">{{ mmsUrl }}</div>
                </div>
                <div class="message-tail"></div>
              </div>
            </div>
          </ng-container>

          <!-- Bubble 2: body text — shown per segment when > 1 -->
          <ng-container *ngIf="splitTwoBubbles">

            <!-- Single segment -->
            <div class="mms-message-bubble" *ngIf="mmsBubble2SegmentParts.length <= 1">
              <div class="mms-message-content">
                <div class="mms-preview-body" *ngIf="mmsBubble2Text; else bubble2Placeholder">{{ mmsBubble2Text }}</div>
                <ng-template #bubble2Placeholder>
                  <div class="mms-preview-placeholder">Write your message here</div>
                </ng-template>
              </div>
              <div class="message-tail"></div>
            </div>

            <!-- Multi-segment: each part as a new message bubble -->
            <ng-container *ngIf="mmsBubble2SegmentParts.length > 1">
              <div class="segment-group"
                   *ngFor="let part of mmsBubble2SegmentParts; let i = index; trackBy: trackByIndex">
                <span class="segment-label">Segment {{ i + 1 }} of {{ mmsBubble2SegmentParts.length }}</span>
                <div class="mms-message-bubble">
                  <div class="mms-message-content">
                    <div class="mms-preview-body">{{ part }}</div>
                  </div>
                  <div class="message-tail"></div>
                </div>
              </div>
            </ng-container>

          </ng-container>
        </div>

        <!-- Cost Breakdown -->
        <div class="mms-cost-breakdown">
          <div class="cost-row">
            <span class="cost-label">Channel</span>
            <span class="cost-value">{{ splitTwoBubbles ? 'MMS + text (two bubbles)' : 'MMS (image + caption)' }}</span>
          </div>
          <div class="cost-row">
            <span class="cost-label">Bubble 1 · MMS</span>
            <span class="cost-value">{{ mmsCaptionSegmentCount }} × $0.022 = ${{ formatCost(mmsCaptionCost) }}</span>
          </div>
          <div class="cost-row" *ngIf="splitTwoBubbles">
            <span class="cost-label">Bubble 2 · SMS</span>
            <span class="cost-value">{{ mmsBubble2SegmentCount }} × $0.0083 = ${{ formatCost(mmsBubble2Cost) }}</span>
          </div>
          <div class="cost-divider"></div>
          <div class="cost-row cost-total-row">
            <span class="cost-total-label">Cost / recipient</span>
            <span class="cost-total-value">${{ formatCost(mmsTotalCost) }}</span>
          </div>
          <p class="cost-fallback-note" *ngIf="mmsFallbackSegmentCount > 0">
            If MMS can't be delivered, fallback sends {{ mmsFallbackSegmentCount }} SMS segment{{ mmsFallbackSegmentCount === 1 ? '' : 's' }} × $0.0083 = ${{ formatCost(mmsFallbackCost) }} (charged only on fallback)
          </p>
        </div>
      </div>
    </div>

    <!-- Modal Footer (SMS) -->
    <div class="modal-footer modal-footer--mms" *ngIf="messageType === 'SMS'">
      <div class="footer-cost-info">
        <span class="footer-cost-amount">Estimated cost ${{ formatCost(smsTotalCost) }}</span>
        <span class="footer-cost-desc">{{ smsTotalSegmentCount }} SMS segment{{ smsTotalSegmentCount === 1 ? '' : 's' }}</span>
      </div>
      <div class="footer-actions">
        <button class="btn btn-secondary" (click)="onClose()">Close</button>
        <button class="btn btn-primary" [disabled]="!isFormValid()" (click)="onSave()">Save</button>
      </div>
    </div>

    <!-- Modal Footer (MMS) -->
    <div class="modal-footer modal-footer--mms" *ngIf="messageType === 'MMS'">
      <div class="footer-cost-info">
        <span class="footer-cost-amount">Estimated cost ${{ formatCost(mmsTotalCost) }}</span>
        <span class="footer-cost-desc">{{ splitTwoBubbles ? 'MMS + text, per recipient' : 'MMS, per recipient' }}</span>
      </div>
      <div class="footer-actions">
        <button class="btn btn-secondary" (click)="onMmsReset()">Reset</button>
        <button class="btn btn-primary" [disabled]="!isMmsFormValid()" (click)="onSave()">Save</button>
      </div>
    </div>
  </div>
</div>
